/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendScenarioDto } from '../../models/backend-scenario-dto';

export interface ProjectCalculationsVariantsKitsList$Params {
  calculation_data?: string;
  desc?: string;
  is_blocked?: boolean;
  is_public?: boolean;
  name?: string;
  needs_recalculation?: boolean;

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  project?: number;

  /**
   * A search term.
   */
  search?: string;
  variant_capex?: number;
  variant_credits?: number;
  variant_discount_rate?: number;
  variant_leasing?: number;
  variant_opexs?: number;
  variant_own_funds?: number;
  variant_sales?: number;
  variant_taxs?: number;
  variant_venture_funds?: number;
  variant_wk?: number;
}

export function projectCalculationsVariantsKitsList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectCalculationsVariantsKitsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendScenarioDto>>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsVariantsKitsList.PATH, 'get');
  if (params) {
    rb.query('calculation_data', params.calculation_data, {});
    rb.query('desc', params.desc, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('is_public', params.is_public, {});
    rb.query('name', params.name, {});
    rb.query('needs_recalculation', params.needs_recalculation, {});
    rb.query('ordering', params.ordering, {});
    rb.query('project', params.project, {});
    rb.query('search', params.search, {});
    rb.query('variant_capex', params.variant_capex, {});
    rb.query('variant_credits', params.variant_credits, {});
    rb.query('variant_discount_rate', params.variant_discount_rate, {});
    rb.query('variant_leasing', params.variant_leasing, {});
    rb.query('variant_opexs', params.variant_opexs, {});
    rb.query('variant_own_funds', params.variant_own_funds, {});
    rb.query('variant_sales', params.variant_sales, {});
    rb.query('variant_taxs', params.variant_taxs, {});
    rb.query('variant_venture_funds', params.variant_venture_funds, {});
    rb.query('variant_wk', params.variant_wk, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendScenarioDto>>;
    }),
  );
}

projectCalculationsVariantsKitsList.PATH = '/api/project_calculations/variants_kits/';
